module.exports = __webpack_public_path__ + "img/6_66.784fd65f.png";